// PatientHeader.jsx — Shared patient info card used across all screens
import s from './shared.module.css';

const patientData = {
  name: 'Priya Mehta',
  age: '34 Years',
  dob: '12 Mar 1991',
  gender: 'Female',
  phone: '+91 98765 43210',
  email: 'priya.mehta@gmail.com',
  location: 'Mumbai, Maharashtra',
  bloodGroup: 'O+',
};

export default function PatientHeader({
  lifeStage = 'Reproductive Age',
  activeJourney = 'Preconception / Fertility Readiness',
  summaryFields = [],
  actions,
}) {
  return (
    <div className={s.patientCard}>
      {/* Avatar */}
      <div className={s.patientAvatar}>
        <svg viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" width="72" height="72">
          <circle cx="36" cy="36" r="36" fill="#EDE9FE"/>
          <ellipse cx="36" cy="30" rx="12" ry="13" fill="#9C27B0"/>
          <ellipse cx="36" cy="62" rx="20" ry="14" fill="#9C27B0"/>
        </svg>
      </div>

      {/* Name + contacts */}
      <div className={s.patientInfo}>
        <p className={s.patientName}>
          {patientData.name}
          <span className={s.verifiedBadge}>✓</span>
        </p>
        <p className={s.patientMeta}>
          {patientData.age} • {patientData.dob} • {patientData.gender}
        </p>
        <div className={s.patientContacts}>
          <span className={s.contactItem}><span className={s.contactIcon}>📞</span>{patientData.phone}</span>
          <span className={s.contactItem}><span className={s.contactIcon}>✉️</span>{patientData.email}</span>
          <span className={s.contactItem}><span className={s.contactIcon}>📍</span>{patientData.location}
            <span style={{ marginLeft: 8, fontSize: 10, color: 'var(--ava-color-primary-700)', fontWeight: 600 }}>
              🩸 {patientData.bloodGroup}
            </span>
          </span>
        </div>
        <button className={s.viewProfileBtn}>View Profile →</button>
      </div>

      {/* Life stage */}
      <div className={s.patientCardCol} style={{ minWidth: 160 }}>
        <p className={s.colLabel}>Life Stage</p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 20 }}>🌸</span>
          <span className={s.lifeStageChip}>{lifeStage}</span>
        </div>
        <p className={s.colLabel} style={{ marginTop: 6 }}>Active Journey</p>
        <p className={s.colValuePink}>{activeJourney}</p>
      </div>

      {/* Summary fields */}
      {summaryFields.length > 0 && (
        <div className={s.patientCardCol} style={{ minWidth: 160 }}>
          <p className={s.colLabel} style={{ fontWeight: 700, marginBottom: 6 }}>
            {summaryFields[0]?.groupLabel || 'Record Summary'}
          </p>
          {summaryFields.map((f, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, fontSize: 11, padding: '2px 0' }}>
              <span style={{ color: 'var(--ava-color-caption)' }}>{f.label}</span>
              <span style={{ color: 'var(--ava-color-heading)', fontWeight: 600 }}>{f.value}</span>
            </div>
          ))}
        </div>
      )}

      {/* Actions slot */}
      {actions && <div style={{ flexShrink: 0 }}>{actions}</div>}
    </div>
  );
}